










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import firebaseApp from '@/firebaseApp'

@Component
export default class SaveStaffName extends Vue {
  @Prop({ required: true }) public value!: string
  @Prop({ required: true }) public restaurantId!: string

  public waiterName = ''
  public showTooltip: boolean = false

  @Watch('value')
  handleValueChange() {
    this.waiterName = this.value
  }

  async saveWaiterName() {
    const saveStaffName = firebaseApp.functions('europe-west1').httpsCallable('saveStaffName')
    try {
      await saveStaffName({
        name: this.waiterName,
        restaurantId: this.restaurantId,
      })

      this.$emit('input', this.waiterName)
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 4000)
    } catch (err) {
      console.error('Opslaan niet gelukt', err)
      alert('Opslaan niet gelukt')
    }
  }
}
